import React from 'react';
import styled from 'styled-components';
import { colors } from '../utils/colors';

const Boloh4 = styled.h4`
	margin-top: 1em;
	color: ${colors.white};
	font-family: 'D-Din', sans-serif;
`;

const Footer = ({ contenido }) => (
	<div>
		<Boloh4>Diario de Cádiz</Boloh4>
      <p style={{color: 'white', opacity: '.7'}}>Avenida del Puerto, 2</p>
	</div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js